import LinkBase from './LinkBase.jsx';

export default function AdditionalLink(props) {
  return (
    <div className="lds-header-mega-menu-container-additional-link">
      <LinkBase {...props} tabIndex="0" />
    </div>
  );
}
